import api from './api';
import { PaginatedResponse } from '../types';

export interface Designer {
  id: string;
  name: string;
  description?: string;
  logoUrl?: string;
  bannerUrl?: string;
  isActive: boolean;
  dressCount: number;
  createdAt: string;
  updatedAt: string;
}

class DesignerService {
  async getDesigners(limit: number = 100): Promise<Designer[]> {
    const response = await api.get<PaginatedResponse<Designer>>('/designers', { limit });
    return response.data.data;
  }

  async getDesignerById(id: string): Promise<Designer> {
    const response = await api.get<{ data: Designer }>(`/designers/${id}`);
    return response.data.data;
  }
}

const designerService = new DesignerService();
export default designerService;